import React from "react";
import { FormProvider } from "react-hook-form";
import { Button, Card, Form, Page } from "@sscs/ui";
import { useLoginInfo } from "Hooks";
import { useUserProfileForm } from "../../hooks";
import styles from "./profile.module.scss";

const Profile = () => {
  const { onSubmit, errors, formMethods } = useUserProfileForm();
  const { isLocalLogin, isSSOLogin } = useLoginInfo();

  return (
    <Page.Root>
      <Page.Header title="Profile" />
      <Page.Body>
        <FormProvider {...formMethods}>
          <Card.Card>
            <Form.Form onSubmit={onSubmit} name="user-profile-form">
              <Card.Content className={styles["settings-form"]}>
                <Form.TextField
                  label="First name"
                  name="firstName"
                  id="firstName"
                  autoComplete="given-name"
                  isRequired
                  isReadOnly={!isLocalLogin}
                  errors={errors}
                />
                <Form.TextField
                  label="Last name"
                  name="lastName"
                  id="lastName"
                  autoComplete="family-name"
                  isRequired
                  isReadOnly={!isLocalLogin}
                  errors={errors}
                />
                <Form.TextField
                  label="Email"
                  name="email"
                  id="email"
                  autoComplete="email"
                  isDisabled
                  isReadOnly={!isLocalLogin}
                  errors={errors}
                />
              </Card.Content>
              {!isSSOLogin && (
                <Card.Actions>
                  <Button
                    id="save"
                    type="submit"
                    color="primary"
                    isFullWidth={false}
                  >
                    Save
                  </Button>
                </Card.Actions>
              )}
            </Form.Form>
          </Card.Card>
        </FormProvider>
      </Page.Body>
    </Page.Root>
  );
};

export default Profile;
